import { Injectable } from '@angular/core';
import { ProductPieces } from './models/product-pieces.model';
import { CuttingPlan, ProfileCut, CutPiece } from './models/cutting-plan.model';

@Injectable({
    providedIn: 'root',
})
export class CuttingOptimizerService {
    constructor() {}

    generateCuttingPlan(
        data: ProductPieces,
        profileLength: number,
        cutWidth: number = 0 // Leikkuuterän leveys (default: 0 mm) (kerf parametri)
    ): CuttingPlan {
        const profiles: ProfileCut[] = [];

        // Group pieces by productCode, color, material
        const groupedPieces = this.groupPiecesByType(data);

        for (const groupKey in groupedPieces) {
            const pieces = groupedPieces[groupKey];

            // Sort descending (longest first) (First-fit decreasing algorithm)
            pieces.sort((a, b) => b.length - a.length);

            pieces.forEach((piece) => {
                let placed = false;

                for (const profile of profiles) {
                    // Huomioidaan, että profiilissa jo olevien palojen määrä vaikuttaa kokonaiskulutukseen
                    const requiredLength =
                        profile.usedLength +
                        piece.length +
                        (profile.pieces.length > 0 ? cutWidth : 0);

                    if (
                        requiredLength <= profileLength &&
                        profile.productCode === piece.productCode &&
                        profile.color === piece.color &&
                        profile.material === piece.material
                    ) {
                        profile.pieces.push(piece);
                        profile.usedLength = requiredLength;
                        profile.leftover = profileLength - profile.usedLength;
                        placed = true;
                        break;
                    }
                }

                if (!placed) {
                    // Jos pala ei sovi olemassa oleviin profiileihin, luodaan uusi
                    profiles.push({
                        id: profiles.length + 1,
                        usedLength: piece.length,
                        leftover: profileLength - piece.length,
                        pieces: [piece],
                        productCode: piece.productCode,
                        color: piece.color,
                        material: piece.material,
                    });
                }
            });
        }

        const totalWaste = profiles.reduce((sum, p) => sum + p.leftover, 0);

        return {
            profileLength,
            totalWaste,
            profiles,
        };
    }

    // Apufunktio ryhmittelyyn (ei muutoksia)
    private groupPiecesByType(data: ProductPieces): { [key: string]: CutPiece[] } {
        const grouped: { [key: string]: CutPiece[] } = {};

        for (const key in data) {
            const product = data[key];
            const groupKey = `${product.productCode}_${product.color}_${product.material}`;

            if (!grouped[groupKey]) {
                grouped[groupKey] = [];
            }

            for (const lengthStr in product.pieces) {
                const quantity = product.pieces[lengthStr];
                const length = parseInt(lengthStr, 10);

                for (let i = 0; i < quantity; i++) {
                    grouped[groupKey].push({
                        productCode: product.productCode,
                        length,
                        color: product.color,
                        material: product.material,
                    });
                }
            }
        }

        return grouped;
    }
}
